module.exports = __webpack_public_path__ + "static/blog-04-07ba9b8ab352f4832aea332f2ca401c1.jpg";